(() => {
  function bind() {
    document.querySelectorAll('[data-cart-form]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      let busy = false;
      form.addEventListener('submit', async event => {
        if (event.submitter?.name === 'checkout') {
          if (busy) event.preventDefault();
          return;
        }
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const updates = {};
        for (const row of form.querySelectorAll('[data-line-key]')) {
          const quantity = Number(row.querySelector('input').value);
          if (!Number.isSafeInteger(quantity) || quantity < 0) return;
          updates[row.dataset.lineKey] = quantity;
        }
        busy = true;
        const status = form.querySelector('[data-cart-status]');
        const buttons = [...form.querySelectorAll('button')];
        buttons.forEach(button => { button.disabled = true; });
        status.textContent = 'Updating cart…';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/update.js', {
            method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({updates}), credentials: 'same-origin'
          });
          const cart = await response.json();
          if (!response.ok) throw new Error(cart.description || 'Unable to update cart. Please try again.');
          if (!cart.items.length) { window.location.reload(); return; }
          const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style:'currency', currency:cart.currency || form.dataset.currency
          }).format(cents / 100);
          for (const row of form.querySelectorAll('[data-line-key]')) {
            const item = cart.items.find(item => item.key === row.dataset.lineKey);
            if (!item) { row.remove(); continue; }
            row.querySelector('input').value = item.quantity;
            row.querySelector('[data-unit-price]').textContent = money(item.final_price);
            row.querySelector('[data-line-total]').textContent = money(item.final_line_price);
          }
          // Merchandise subtotal only; checkout remains authoritative for shipping/tax.
          const merchandiseSubtotal = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
          form.querySelector('[data-cart-total]').textContent = money(merchandiseSubtotal);
          document.querySelectorAll('a.cart').forEach(link => { link.textContent = `Cart (${cart.item_count})`; });
          status.textContent = 'Cart updated.';
        } catch (error) {
          status.textContent = error.message || 'Unable to update cart. Please try again.';
        } finally {
          busy = false;
          buttons.forEach(button => { button.disabled = false; });
        }
      });
    });
  }
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
